import React, { useState } from 'react';
import { resourceNavigation } from './resourceNavigation';

const ResourceLink = ({ link }) => (
  <a href={link.href} target="_blank" rel="noopener noreferrer">
    {link.label}
  </a>
);

const ResourceMenu = () => {
  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  return (
    <div className="resourceMenu">
      {resourceNavigation.map((item) => {
        if (!item.links) {
          return (
            <div className="resourceMenu__item" key={item.href}>
              <ResourceLink link={item} />
            </div>
          );
        }

        const isExpanded = activeSection === item.id;

        return (
          <div className="resourceMenu__item" key={item.id}>
            <button
              type="button"
              className="resourceMenu__toggle"
              aria-expanded={isExpanded}
              onClick={() => toggleSection(item.id)}
            >
              <span>{item.label}</span>
              <i className={`fas fa-chevron-${isExpanded ? 'up' : 'down'}`} aria-hidden="true"></i>
            </button>
            <ul hidden={!isExpanded}>
              {item.links.map((link) => (
                <li key={link.href}>
                  <ResourceLink link={link} />
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default ResourceMenu;